module.exports = __webpack_public_path__ + "img/1.6bb94e8f.png";